import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import axios from "axios";
require("dotenv").config();
import './assets/fonts.css';

//   const host = window.location.hostname; // разкомментить для билда тестовой среды
// `http://${host}:8090` // разкомментить для билда тестовой среды
// process.env.VUE_APP_API_HOST // разкомментить для билда на продакшен
// axios.defaults.baseURL = process.env.VUE_APP_API_HOST; // разкомментить для билда на продакшен, нужно чтобы был env файл с переменной
// axios.defaults.baseURL = `http://${host}:8090`; // разкомментить для билда тестовой среды
 axios.defaults.baseURL = process.env.VUE_APP_API_HOST
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
	config.headers["Content-Type"] = "application/json";
	config.headers["Access-Control-Allow-Origin"] = "*";
	config.headers["Access-Control-Allow-Methods"] =
		"GET, POST, PUT, DELETE, OPTIONS";
	config.headers["Access-Control-Allow-Headers"] =
		"Origin, X-Requested-With, Content-Type, Accept, Authorization";
	config.headers["Accept-Language"] =
		"ru";
	return config;
});

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");